// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__9sDk7","outline":"button_outline__78tFF","light":"button_light__7nQPu","fill":"button_fill__qpzMd"};